import { colorStrings, fontFamily } from "@iewc/Utilities/variables";
import { ButtonPresentationProps } from "@insite/mobius/Button";

export const buttonCommon: ButtonPresentationProps = {
    shape: "rectangle",
    activeMode: "lighten",
    hoverMode: "lighten",
    sizeVariant: "medium",
    typographyProps: {
        weight: 600,
        fontFamily,
        size: 18,
    },
    mergeCss: true,
};

export const button: {
    defaultProps?: ButtonPresentationProps;
    primary: ButtonPresentationProps;
    secondary: ButtonPresentationProps;
    tertiary: ButtonPresentationProps;
} = {
    primary: {
        ...buttonCommon,
        color: colorStrings.primaryMain,
        activeMode: "darken",
        hoverMode: "darken",
    },
    secondary: {
        ...buttonCommon,
        color: colorStrings.secondaryMain,
        buttonType: "outline",
    },
    tertiary: {
        ...buttonCommon,
        color: colorStrings.primaryMain,
        buttonType: "outline",
    },
};
